var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubjectTitle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7.14286C3 4.30254 5.26656 2 8.0625 2H19.3125C20.2444 2 21 2.76751 21 3.71429V20.8571C21 21.4883 20.4963 22 19.875 22H6.9375C4.95386 22 3.31282 20.5098 3.03987 18.5714H3V7.14286ZM19.3125 15.7143H6.9375C5.69486 15.7143 4.6875 16.7376 4.6875 18C4.6875 19.2624 5.69486 20.2857 6.9375 20.2857H19.3125V15.7143ZM7.78125 7.14286C7.78125 6.66947 8.15901 6.28571 8.625 6.28571H16.5C16.966 6.28571 17.3438 6.66947 17.3438 7.14286C17.3438 7.61624 16.966 8 16.5 8H8.625C8.15901 8 7.78125 7.61624 7.78125 7.14286ZM8.625 9.71429C8.15901 9.71429 7.78125 10.0981 7.78125 10.5714C7.78125 11.0448 8.15901 11.4286 8.625 11.4286H14.25C14.716 11.4286 15.0938 11.0448 15.0938 10.5714C15.0938 10.0981 14.716 9.71429 14.25 9.71429H8.625Z",
    fill: "#4F565E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubjectTitle);
export default __webpack_public_path__ + "static/media/subject-title.2657d966bfd5d90233cb59c76440d072.svg";
export { ForwardRef as ReactComponent };